import Navigator from '../../../../components/common/Navigator'
import InternshipCreate from './create'
export default function InternshipForm() {
  return (
    <div className="lg:py-6 p-4 lg:w-11/12 lg:mx-auto   ">
      <div className="mb-6 border-b border-primaryBlue pb-4">
        <Navigator title="Internship Form" slug="INTERNSHIPFORM" />
        <h1 className="text-3xl font-semibold text-gray-900">Internship</h1>
        <p className="text-md text-LightGray mt-1">
          Gain hands-on experience, build real-world skills, and contribute to
          impactful projects through our internship program
        </p>
      </div>
      <InternshipCreate />
    </div>
  )
}
